import PropTypes from 'prop-types';
import React from 'react';
import uuid from 'uuid';
import { Container } from 'react-bootstrap';
import { connect } from 'react-redux';
import { getColors } from 'store/modules/site';
import { fromNamed as translateColor } from 'utils/colors';
import { compose } from 'utils/react';
import Video from '../../../../website/components/stateless/Video';
import { OPTION_PATTERN } from '../sections/decorators/backgroundSettings';
import { OPTION_BEHINDCONTENTAREA, OPTION_FULLOVERLAY } from '../sections/decorators/overlaySetting';
import { ID as CarouselID } from '../../../../website/widgets/dynamic/Carousel/properties';
import classes from './Section.scss';

const isColorGradient = color =>
  /linear-gradient|radial-gradient/.test(color || '');

function prepareClassName(backgroundStyle, backgroundPattern, className) {
  const classNames = [classes?.section, className];
  if (
    backgroundStyle === 'pattern' ||
    backgroundPattern?.value === OPTION_PATTERN
  ) {
    classNames.push(classes.patternDoors);
  }

  return classNames.filter(Boolean).join(' ');
}

const Section = ({
  children,
  className,
  backgroundColor,
  backgroundStyle,
  backgroundPattern,
  contentBackground,
  inlineStyle,
  overlayType,
  overlay,
  backgroundVideoURL,
  backgroundVideoAltText,
  backgroundVideoTitleText,
  backgroundVideoSource,
  images,
  slideshowSetting,
  Carousel,
}) => {
  let sectionStyle = {};
  const sectionContainerStyle = {
    background: 'transparent',
  };
  const contentGridStyle = {
    backgroundColor: contentBackground,
  };

  sectionStyle.backgroundColor = backgroundColor;
  sectionStyle = { ...sectionStyle, ...inlineStyle };

  switch (backgroundStyle) {
    case 'color':
      sectionContainerStyle.background = backgroundColor;
      break;
    default:
      break;
  }

  if (overlayType === OPTION_FULLOVERLAY && overlay !== 'transparent') {
    sectionStyle.backgroundColor = overlay;
  }

  if (overlayType === OPTION_BEHINDCONTENTAREA && overlay !== 'transparent') {
    contentGridStyle.backgroundColor = overlay;
    if (isColorGradient(overlay)) {
      contentGridStyle.background = overlay;
    }
  }

  const isVideoBackground = backgroundStyle === 'video' && backgroundVideoURL && backgroundVideoSource;

  const CarouselWidget = { ...Carousel };

  if (backgroundStyle === 'image' && images && images.length > 0) {
    if (!CarouselWidget?.props?.widget) {
      CarouselWidget.props = {
        ...CarouselWidget.props,
        widget: {
          componentId: CarouselID,
          id: uuid.v4(),
          type: 'Carousel',
          payload: null,
        },
        componentId: CarouselID,
        id: uuid.v4(),
        type: 'Carousel',
        payload: null,
      };
    }
  }

  const sectionChildren = (
    <div
      className={prepareClassName(
        backgroundStyle,
        backgroundPattern,
        className,
      )}
      style={sectionStyle}
    >
      <Container style={contentGridStyle}>{children}</Container>
    </div>
  );

  if (backgroundStyle === 'image' && images && images.length > 0) {
    return (
      <div className={classes.root}>
        {React.cloneElement(CarouselWidget, {
          images,
          slideshowSetting,
          isSectionBackground: true,
        })}
        <div className={classes.container}>{sectionChildren}</div>
      </div>
    );
  }

  return (
    <div
      style={{
        position: 'relative',
        background: sectionContainerStyle.background,
      }}
    >
      {isVideoBackground && (
        <div
          className={classes.vdContainer}
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            zIndex: 0,
          }}
        >
          <Video
            url={backgroundVideoURL}
            altText={backgroundVideoAltText}
            title={backgroundVideoTitleText}
            autoPlay
            loop
            mute
            controls={false}
            videoSource={backgroundVideoSource}
            isSectionBackground
          />
        </div>)}
      <div
        style={{
          background: overlayType === OPTION_FULLOVERLAY ? overlay : 'transparent',
          position: 'relative',
        }}
      >
        <div
          className={prepareClassName(backgroundStyle, backgroundPattern, className)}
          style={sectionStyle}
        >
          <Container style={contentGridStyle}>
            {children}
          </Container>
        </div>
      </div>
    </div>
  );
};

Section.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  background: PropTypes.string,
  backgroundColor: PropTypes.string,
  backgroundStyle: PropTypes.string,
  inlineStyle: PropTypes.object,
  backgroundPattern: PropTypes.object,
  overlayType: PropTypes.string,
  overlayColor: PropTypes.string,
};

export default compose(
  connect(
    (
      state,
      { backgroundColor, backgroundStyle, contentBackground, overlay },
    ) => {
      const colors = getColors(state);
      return {
        backgroundColor: translateColor(colors, backgroundColor),
        contentBackground: translateColor(colors, contentBackground),
        overlay: translateColor(colors, overlay),
        backgroundStyle,
      };
    },
    null,
  ),
)(Section);
